import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { USERS_API_URL } from '../../config/apiConfig';
import './ForgotPasswordScreen.css';

const ForgotPasswordScreen = () => {
  const location = useLocation();
  const [identifier, setIdentifier] = useState(location.state?.username || '');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${USERS_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ identifier })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        throw new Error(data.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (success) {
    return (
      <div className="forgot-password-screen">
        <div className="forgot-password-container">
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Check Your Email</h2>
            <p>
              If an account with that username or email exists, we've sent a reset
              link to the email address on file.
            </p>
            <p>
              Please check your inbox and follow the instructions to reset your password.
              The link will expire in 1 hour.
            </p>
            <button 
              className="back-to-login-button"
              onClick={handleBackToLogin}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-screen">
      <div className="forgot-password-container">
        <div className="forgot-password-header">
          <h1>Reset Password</h1>
          <p>Enter your username or email address and we'll send a reset link to the email on file for that account.</p>
        </div>
        
        <form onSubmit={handleSubmit} className="forgot-password-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="identifier">Username or email address</label>
            <input
              type="text"
              id="identifier"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
              disabled={loading}
              autoFocus
              placeholder="Enter your username or email"
            />
          </div>
          
          <div className="button-group">
            <button 
              type="submit" 
              className="reset-button"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            
            <button 
              type="button" 
              className="cancel-button"
              onClick={handleBackToLogin}
              disabled={loading}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
